import { Box, Modal, Typography } from "@mui/material";
import { IModalFunctionalLocationsSettings } from "./AddAreaOrFunctionalLocationModalInterfaces";
import { useStyles, modalStyles } from "./AddAreaOrFunctionalLocationModal.styles";

export const AddAreaOrFunctionalLocationModal = ({
    open,
    handleClose,
    title,
    children,
}: IModalFunctionalLocationsSettings) => {
    const classes = useStyles();
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={modalStyles}>
                <Typography className={classes.modalTitle}>{title}</Typography>
                <Box className={classes.bodyContainer}>{children}</Box>
            </Box>
        </Modal>
    );
};
